import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Modal } from 'modules/common/components';
import { ContactForm } from 'modules/contact/components';

ContactModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

function ContactModal({ handleClose }) {
  const { t } = useTranslation(['dashboard']);

  return (
    <Modal show onHide={handleClose} hasCloseCross>
      <h1 className="Typography Typography--title u-weight-600 u-pb-40">
        {t('dashboard:contact_title')}
      </h1>

      <ContactForm onClose={handleClose} />
    </Modal>
  );
}

export default ContactModal;
